const baseURL = "https://mitr.com.vn";
console.log('baseURL: ' + baseURL)
export { baseURL };

